module.exports = __webpack_public_path__ + "img/1.570ab764.png";